import { TYPE_STRING } from './input-types';

export const id = 'email';
export const apiKey = 'BuyerEmail';
export const type = TYPE_STRING;

export const email = {
  id,
  apiKey,
  type,
};
